import { ActionKeys } from '~/actions/constants';
import * as gtmActions from '~/actions/gtm.actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getUserId } from '~/selectors/user.selectors';
import * as gtmService from '~/services/gtm.service';
import { selectState } from '..';

export function* sendGTMEvent(action: ReturnType<typeof gtmActions.sendGTMEvent>) {
  const userId: number = yield selectState<number | undefined | null>(getUserId) || -1;
  const firedTime = new Date().toISOString();
  const eventName = action.payload.eventName;

  const payload = {
    eventName: action.payload.eventName,
    data: {
      // Backwards compatibility with events defined in GTM already
      ...action.payload.data,
      // New format, change existing variables in GTM to follow this
      [eventName]: {
        userId,
        firedTime,
        ...action.payload.data,
      },
    },
  };

  try {
    yield call(gtmService.sendGTMEvent, payload);
    yield put(gtmActions.sendGTMEventSuccess(action.payload.eventName));
  } catch (e) {
    yield put(gtmActions.sendGTMEventError(action.payload.eventName, (e as Error).toString()));
  }
}

export function* pushToGTMDataLayer(action: ReturnType<typeof gtmActions.pushToGTMDataLayer>) {
  try {
    yield call(gtmService.pushToGTMDataLayer, action.payload);
    yield put(gtmActions.pushToGTMDataLayerSuccess());
  } catch (e) {
    yield put(gtmActions.pushToGTMDataLayerError((e as Error).toString()));
  }
}

export default [
  takeLatest(ActionKeys.SEND_GTM_EVENT, sendGTMEvent),
  takeLatest(ActionKeys.PUSH_TO_GTM_DATA_LAYER, pushToGTMDataLayer),
];
